import { useState } from "react";
import '../../Styles/EditWorkerModal.css'
function EditWorkerModal({ show, worker, onClose, onSave }) {
    const [workerName, setWorkerName] = useState(worker.workerName);
    const [companyName, setCompanyName] = useState(worker.companyName);
    const [roles, setRoles] = useState(worker.roles.join(', '));
  
    const handleSave = () => {
        const updatedWorker = {
           ...worker,
           workerName,
           companyName,
           roles: roles.split(',').map(role => role.trim())
        };
        onSave(updatedWorker);
      };
      
  
    return (
      show && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={onClose}>&times;</span>
            <label>Medarbejders navn</label>
            <input type="text" value={workerName} onChange={(e) => setWorkerName(e.target.value)} />          
            <label>Roller</label>
            <input type="text" value={roles} onChange={(e) => setRoles(e.target.value)} />
            <button onClick={handleSave}>Save</button>
          </div>
        </div>
      )
    );
}

  export default EditWorkerModal;